import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { PLATFORMS, PLATFORM_LABELS } from "@/lib/helpers";

export default function Matrix() {
  const [items, setItems] = useState([]);
  const [connected, setConnected] = useState([]);
  useEffect(() => {
    api.get("/products", { params: { limit: 200 } }).then(r => setItems(r.data.items));
    api.get("/platforms").then(r => setConnected(r.data.items.map(c => c.platform)));
  }, []);

  return (
    <div className="space-y-6 min-w-0" data-testid="matrix-page">
      <div>
        <div className="eyebrow mb-1">Availability Matrix</div>
        <h1 className="font-display font-bold text-3xl lg:text-4xl tracking-tighter text-navy">Where is my product?</h1>
        <p className="text-muted-foreground mt-2 text-sm">Live / Missing / Draft across every marketplace. Unconnected platforms are dimmed.</p>
      </div>

      <div className="card-base overflow-hidden">
        <div className="scroll-x">
          <table className="table-base">
            <thead>
              <tr>
                <th>Product</th>
                {PLATFORMS.map(p => (
                  <th key={p} className="text-center">
                    {PLATFORM_LABELS[p]}
                    {!connected.includes(p) && <div className="text-[9px] font-normal text-muted-foreground normal-case tracking-normal mt-0.5">not connected</div>}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {items.map(p => (
                <tr key={p.id}>
                  <td>
                    <div className="flex items-center gap-3 min-w-0">
                      {p.images?.[0]?.url && <img src={p.images[0].url} className="w-8 h-8 border border-border rounded object-cover shrink-0" alt="" onError={(e)=>{e.target.style.visibility='hidden';}}/>}
                      <div className="font-medium text-navy truncate">{p.name}</div>
                    </div>
                  </td>
                  {PLATFORMS.map(pl => {
                    const l = p.listings?.find(x => x.platform === pl);
                    const s = l?.status;
                    const isConn = connected.includes(pl);
                    return (
                      <td key={pl} className="text-center">
                        {isConn && s
                          ? <span className={`pill pill-${s.toLowerCase()}`}>{s}</span>
                          : <span className="text-xs text-muted-foreground/50">—</span>}
                      </td>
                    );
                  })}
                </tr>
              ))}
              {items.length === 0 && (
                <tr><td colSpan={PLATFORMS.length + 1} className="text-center text-muted-foreground py-10 text-sm">No products yet.</td></tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
